const C = {
  Branca: "#F8FAFC", Azul: "#2563EB", Roxa: "#7C3AED", Marrom: "#78350F", Preta: "#09090B", Cinza: "#6B7280",
  Amarela: "#EAB308", Laranja: "#F97316", Verde: "#16A34A", Vermelha: "#DC2626",
};

function beltBg(name = "Branca") {
  if (name === "Coral") return "repeating-linear-gradient(90deg,#DC2626 0 16px,#09090B 16px 32px)";
  if (name === "Vermelha e Branca") return "repeating-linear-gradient(90deg,#DC2626 0 16px,#F8FAFC 16px 32px)";
  const [main, second] = name.split("-");
  const m = C[main] || "#E5E7EB";
  if (!second) return m;
  const s = C[second === "Preta" ? "Preta" : "Branca"];
  return `linear-gradient(180deg, ${m} 0 36%, ${s} 36% 64%, ${m} 64% 100%)`;
}

export function Belt({ belt = "Branca", grau = 0, size = "md", testid }) {
  const h = size === "lg" ? "h-9" : size === "sm" ? "h-4" : "h-6";
  const w = size === "lg" ? "w-full max-w-sm" : size === "sm" ? "w-20" : "w-32";
  const bar = belt === "Preta" ? "#DC2626" : "#09090B";
  return (
    <div className={`flex items-center gap-2`} data-testid={testid}>
      <div className={`relative ${h} ${w} rounded-[3px] overflow-hidden ring-1 ring-black/15 shadow-sm`} style={{ background: beltBg(belt) }}>
        <div className="absolute right-[10%] top-0 bottom-0 w-[30%] flex items-center justify-end gap-[3px] px-[4px]" style={{ background: bar }}>
          {Array.from({ length: grau }).map((_, i) => (
            <span key={i} className="h-full w-[3px] bg-white" />
          ))}
        </div>
      </div>
    </div>
  );
}

export const beltLabel = (b, g) => `${b || "Branca"}${g ? ` · ${g}º grau` : ""}`;
